export default "__VITE_ASSET__KmwA5jkx__"